import clsx from 'clsx';

const map = {
  // Ordens de serviço / sistema
  aberta: 'bg-accent/20 text-accent',
  diagnóstico: 'bg-cyan-500/20 text-cyan-300',
  'aguardando aprovação': 'bg-amber-500/20 text-amber-300',
  'em execução': 'bg-info/20 text-info',
  'aguardando peça': 'bg-warning/20 text-warning',
  finalizada: 'bg-success/20 text-success',
  entregue: 'bg-zinc-700 text-zinc-200',
  atrasada: 'bg-danger/20 text-danger',
  cancelada: 'bg-danger/20 text-danger',
  vip: 'bg-warning/20 text-warning',
  // Backoffice GDN — assinaturas
  ativo: 'bg-success/20 text-success',
  trial: 'bg-info/20 text-info',
  pendente: 'bg-warning/20 text-warning',
  atrasado: 'bg-danger/20 text-danger',
  bloqueado: 'bg-danger/20 text-danger',
  cancelado: 'bg-zinc-600 text-zinc-300',
  inativo: 'bg-zinc-600 text-zinc-300',
  expirado: 'bg-danger/20 text-danger',
  // Backoffice GDN — parceiros
  novo: 'bg-accent/20 text-accent',
  'em analise': 'bg-info/20 text-info',
  em_analise: 'bg-info/20 text-info',
  aprovado: 'bg-success/20 text-success',
  reprovado: 'bg-danger/20 text-danger',
  pagante: 'bg-success/20 text-success',
  'cliente pagante': 'bg-success/20 text-success',
  'teste grátis': 'bg-info/20 text-info',
};

export default function Badge({ children, tone, className }) {
  const key = (tone || String(children || '')).toLowerCase().trim();
  return (
    <span className={clsx('inline-flex items-center whitespace-nowrap rounded-full px-2.5 py-0.5 text-xs font-medium', map[key] || 'bg-zinc-700 text-zinc-200', className)}>
      {children}
    </span>
  );
}


